import FilterBottonsBlock from './FilterBottonsBlock.vue';

export * from './types';
export default FilterBottonsBlock;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/calendar/components/calendarfilter/components/filterbottonsblock/index.ts